import React, { useState } from "react";
import { Link } from "react-router-dom";

import EditorialSearch from './EditorialSearch.js';

export default function Editorial() {
    const [heroStats, setHeroStats] = useState({ guides: 0, lawyers: 0, firms: 0 });

    return (
        <main className="firm-editorial-page editorial-page">
            <section className="hero firm-hero">
                <p className="guides-return-row">
                    <Link className="guides-return-link" to="/guides">Return to Portal</Link>
                </p>
                <div className="firm-hero__eyebrow">Editorial search</div>
                <h1>Browse Editorial History</h1>
                <p className="firm-hero__summary">
                    Search lawyers and firms by guide, then jump straight to the editorial pages for rankings, feedback, and notable practitioners.
                </p>
                <div className="firm-hero__stats">
                    <div className="firm-hero__stat">
                        <span className="firm-meta-label">Guides loaded</span>
                        <span className="firm-meta-value">{heroStats.guides}</span>
                    </div>
                    <div className="firm-hero__stat">
                        <span className="firm-meta-label">Lawyers</span>
                        <span className="firm-meta-value">{heroStats.lawyers}</span>
                    </div>
                    <div className="firm-hero__stat">
                        <span className="firm-meta-label">Firms</span>
                        <span className="firm-meta-value">{heroStats.firms}</span>
                    </div>
                </div>
            </section>

            <EditorialSearch onStatsChange={setHeroStats} />
        </main>
    );
}